'use client';

import { BarChart } from '@mantine/charts';
import ChartTooltip from './ChartTooltip';

type Data = {
  grade: string;
  Climbs: number;
};

function convertToChartData(climbs: Climb[]) {
  // Create an object to store data for each grade
  const data = {};

  // Iterate through the ascents array and populate the data object
  climbs.forEach((climb) => {
    const key = climb.grade;

    if (!data[key]) {
      data[key] = {
        grade: key,
        Climbs: 0,
      };
    }

    // Increment the appropriate category based on climb details
    data[key].Climbs += 1;
  });

  // Convert the data object into an array
  const chartData = Object.values(data) as Data[];

  // Sort the chartData array by grade
  chartData.sort((a, b) =>
    a.grade.localeCompare(b.grade, 'en', {
      numeric: true,
    }),
  );

  return chartData;
}

export default function GradeBarChart({ data }) {
  const dataset = convertToChartData(data);

  return (
    <BarChart
      h={256}
      data={dataset}
      dataKey='grade'
      tickLine='y'
      tooltipProps={{
        content: ({ label, payload }) => (
          <ChartTooltip label={label} payload={payload} />
        ),
      }}
      series={[{ name: 'Climbs', color: 'brand.7' }]}
    />
  );
}
